import '../../css/app.css'
import { createApp, h } from 'vue'
import { createInertiaApp, Head, Link } from '@inertiajs/inertia-vue3'
import '@fortawesome/fontawesome-pro/js/all.min.js'

import AOS from 'aos'
import 'aos/dist/aos.css'

import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

AOS.init()

const options = {
	position: 'top-right',
	timeout: 5000,
	closeOnClick: true,
	pauseOnFocusLoss: true,
	pauseOnHover: true,
	draggable: true,
	draggablePercent: 0.6,
	showCloseButtonOnHover: false,
	hideProgressBar: true,
	closeButton: 'button',
	icon: true,
	rtl: false,
}

createInertiaApp({
	title: (title) => `${title} - Beepbeep`,
	resolve: (name) => import(`./Pages/${name}`),
	setup({ el, App, props, plugin }) {
		const app = createApp({ render: () => h(App, props) })
			.use(plugin)
			.component('Link', Link)
			.component('Head', Head)
			.use(Toast, options)

		app.config.globalProperties.$isPromotion = [4, 5, 6, 0].includes(new Date().getDay())

		app.mount(el)

		return app
	},
})
